/**
 * NOTE: If you're modifying items in this file, please add a member of the
 * Data team to your PR. Also, some of the values in these enums don't match
 * their keys on purpose in an effort to standardize on terminology used.
 *
 * For more detail on these values, please see the glossary:
 * http://go.atlassian.com/trello-analytics-glossary
 */

export enum Schema {
  ClientEvent = 'iglu:com.trello/client-event/jsonschema/1-0-0',
  ExperimentEvent = 'iglu:com.trello/experiment-event/jsonschema/1-0-0',
}

export enum Noun {
  AA_MIGRATION_WIZARD = 'aa migration wizard',
  ACCOUNT = 'account',
  ACTIVITY = 'activity',
  ACTIVITY_FEED = 'activity feed',
  ATLASSIAN_ACCOUNT_ONBOARDING = 'atlassian account onboarding',
  ADD_MEMBERS_MENU = 'add members menu',
  ADD_MENU = 'add menu',
  ADD_TO_ENTERPRISE_POPOVER = 'add to enterprise popover',
  ADMIN = 'admin',
  ADMIN_LIST_POPOVER = 'admin list popover',
  ALWAYS_OPEN_MENU_DEFAULT = 'always open menu default',
  ALL_TAB = 'all tab',
  ALL_NOTIFICATIONS = 'all notifications',
  ALLOWED_TAB = 'allowed tab',
  ANNOUNCEMENTS = 'announcements',
  ARCHIVE = 'archive',
  ASSIGN_MEMBER_DIALOGUE = 'assign member dialogue',
  ATLASSIAN_APP_SWITCHER = 'atlassian app switcher',
  ATLASSIAN_APP_SWITCHER_BUTTON = 'atlassian app switcher button',
  ATTACHMENT = 'attachment',
  AVATAR = 'avatar',
  AVATAR_POPOVER = 'avatar popover',
  AVATAR_SOURCE = 'avatar source',
  BACKGROUND = 'background',
  BANNER = 'banner',
  BC_MODAL = 'bc modal',
  BILLING = 'billing',
  BILLING_FREQUENCY = 'billing frequency',
  BILLING_PAGE = 'billing page',
  BOARD = 'board',
  BOARD_HEADER = 'board header',
  BOARD_BACKGROUND = 'board background',
  BOARD_SIDEBAR = 'board sidebar',
  BOARD_MAP = 'board map',
  BOARD_MENU = 'board menu',
  BOARD_SEARCH_RESULT = 'board search result',
  BOARD_SHORT_URL = 'board short url',
  BOARD_VIEW = 'board view',
  BOARDS = 'boards',
  BOARDS_FILTER = 'boards filter',
  BOARDS_MENU = 'boards menu',
  BOARDS_PAGE = 'boards tab',
  BOARDS_TAB = 'boards tab',
  BULK_ACTIONS_MENU = 'bulk actions menu',
  BUSINESS_CLASS = 'business class',
  BUSINESS_CLASS_FREE_TRIAL = 'business class free trial',
  BUSINESS_CLASS_ADVANCED_CHECKLIST_UPSELL = 'business class advanced checklist upsell',
  BUSINESS_CLASS_FEATURE = 'business class feature',
  BUSINESS_CLASS_PAYMENT = 'business class payment',
  BUSINESS_CLASS_UPSELL = 'business class upsell',
  BUSINESS_CLASS_FREE_TRIAL_UPSELL = 'business class free trial upsell',
  BUSINESS_CLASS_MARKETING_PAGE = 'business class marketing page',
  BUSINESS_CLASS_SUMMARY = 'business class summary',
  CATEGORY = 'category',
  CATEGORY_TILE = 'category tile',
  CARD = 'card',
  CARD_BACK = 'card back', // Standardizing on terminology
  CARD_COMPOSER = 'card composer',
  CARD_DESCRIPTION = 'card description',
  CARD_DETAIL = 'card detail',
  CARD_DETAILS = 'card details',
  CARD_FRONT = 'card', // Standardizing on terminology
  CARD_SEARCH_RESULT = 'card search result',
  CARD_SIDEBAR = 'card sidebar',
  CARD_TEMPLATE = 'card template',
  CARD_TEMPLATES = 'card templates',
  CARD_TEMPLATES_MENU = 'card templates menu',
  CARDS_WITH_LABEL = 'cards with label',
  CONNECTION_FAILURE_ALERT = 'connection failure alert',
  CARDS = 'cards',
  CHANGE_CREDIT_CARD_POPOVER = 'update credit card popover',
  CHANGE_DUE_DATE_PICKER = 'change due date picker',
  CHANGE_MEMBER_DIALOGUE = 'change member dialogue',
  CHANGE_MONTHLY_BUTTON = 'change monthly button',
  CHANGE_PASSWORD = 'change password',
  CHANGE_TEAM_MENU = 'change team menu',
  CHANGE_YEARLY_BUTTON = 'change yearly button',
  CHECKLIST = 'checklist',
  CHECKLIST_ITEM = 'checklist item',
  CLOSED_BOARDS = 'closed boards',
  COLLAPSIBLE_SECTION = 'collapsible section',
  COLLECTION = 'collection',
  COMMENT = 'comment',
  COMMENT_FIELD = 'comment field',
  COMMENT_TEXT = 'comment text',
  COPY_BOARD_MENU = 'copy board menu',
  CREATE_BOARD_MODAL = 'create board modal',
  CREATE_BOARD_POPOVER = 'create board popover',
  CREATE_CARD_FROM_TEMPLATE_MENU = 'create card from template menu',
  CREATE_TEAM_MODAL = 'create team modal',
  CREATE_TEAM_MENU = 'create team menu',
  DESKTOP_NOTIFICATIONS = 'desktop notifications',
  DISABLED_TAB = 'disabled tab',
  DOWNLOAD_BOARD_EXPORT = 'download board export',
  DUE_DATE = 'due date',
  DUE_DATE_PICKER = 'due date picker',
  EMAIL = 'email',
  EMAIL_FREQUENCY = 'email frequency',
  EMAIL_FREQUENCY_MENU = 'email frequency menu',
  EMAIL_HYGIENE = 'email hygiene',
  EMAIL_HYGIENE_WIZARD = 'email hygiene wizard',
  EMAIL_HYGIENE_WIZARD_SCREEN_CHOOSE_EMAIL = 'email hygiene wizard screen chooseEmail',
  EMAIL_HYGIENE_WIZARD_SCREEN_CONFIRM_SINGLE_EMAIL = 'email hygiene wizard screen confirmSingleEmail',
  EMAIL_HYGIENE_WIZARD_SCREEN_CONFIRMATION_EMAIL_SENT = 'email hygiene wizard screen confirmationEmailSent',
  EMAIL_HYGIENE_WIZARD_SCREEN_CLAIMABLE_INFO = 'email hygiene wizard screen claimableInfo',
  EMAIL_HYGIENE_WIZARD_SCREEN_SUCCESS = 'email hygiene wizard screen success',
  EMAIL_HYGIENE_WIZARD_SCREEN_ERROR = 'email hygiene wizard screen error',
  ENTERPRISE = 'enterprise',
  ENTERPRISE_DASHBOARD = 'enterprise dashboard',
  ENTERPRISE_DASHBOARD_MENU = 'enterprise dashboard menu',
  ENT_DASH_POWER_UPS_TAB = 'enterprise dashboard power-ups tab',
  ENT_DASH_POWER_UPS_TAB_INTRODUCTION_PAGE = 'enterprise dashboard power ups tab introduction page',
  ENT_DASH_SSO_SETTINGS_TAB = 'enterprise dashboard SSO settings tab',
  ENT_DASH_NON_ENT_TEAMS_TAB = 'enterprise dashboard non-enterprise teams tab',
  ENTERPRISE_MARKETING_PAGE = 'enterprise marketing page',
  ENTERPRISE_UPSELL = 'enterprise upsell',
  ERROR = 'error',
  EXPORT_BOARD = 'export board',
  EXPORT_DATA_MENU = 'export data menu',
  EXPORT_OPTION = 'export option',
  EXPORT_POPOVER = 'export popover',
  EXTERNAL_MAP = 'external map',
  MODEL_CACHE_TO_APOLLO_CACHE_SYNCING = 'model cache to apollo cache syncing',
  FREE_TEAM_LIMIT_RESTRICTED_BANNER = 'red free team limit warning',
  FREE_TEAM_LIMIT_RESTRICTED_BANNER_BUSINESS_CLASS_LINK = 'business class link on red free team limit warning',
  FREE_TEAM_LIMIT_RESTRICTED_BANNER_ENTERPRISE_LINK = 'enterprise link on red free team limit warning',
  FREE_TEAM_LIMIT_RESTRICTED_MESSAGE = 'red warning',
  FREE_TEAM_LIMIT_WARNING_BANNER = 'yellow free team limit warning',
  FREE_TEAM_LIMIT_WARNING_BANNER_BUSINESS_CLASS_LINK = 'business class link on yellow free team limit warning',
  FREE_TEAM_LIMIT_WARNING_BANNER_ENTERPRISE_LINK = 'enterprise link on yellow free team limit warning',
  FREE_TEAM_LIMIT_WARNING_MESSAGE = 'yellow warning',
  FREE_TEAM_LIMIT_WARNING_MESSAGE_ENTERPRISE_LINK = 'learn more link in yellow warning in team builder',
  FREE_TEAM_LIMIT_WARNING_MESSAGE_BUSINESS_CLASS_LINK = 'business class link in yellow warning in team builder',
  FREE_TEAM_LIMIT_BLOCKED_POPOVER = 'create team popover on board view when blocked from creating teams',
  FREE_TEAM_LIMIT_BLOCKED_POPOVER_ENTERPRISE_LINK = 'learn more button in create team popover on board view when blocked from creating teams',
  FREE_TEAM_LIMIT_RESTRICTION_MESSAGE_ENTERPRISE_BUTTON = 'learn more primary button in team builder',
  FREE_TEAM_LIMIT_RESTRICTION_MESSAGE_TEAM_BUILDER = 'no teams remaining message',
  FROM_A_COMMENT = 'from a comment',
  FOR_EMOJI = 'for emoji',
  GIPHY_STICKER = 'giphy sticker',
  GOLD = 'gold',
  GOLD_LINK = 'trello.com/gold link',
  GLOBAL_CLICK_HANDLER = 'global click handler',
  HEADER = 'header',
  HEADER_TIPS = 'header tips',
  HELP = 'help',
  HELP_DOC_LINK = 'trello help document link',
  HIGHLIGHTS = 'highlights',
  HOME = 'home',
  HOME_TEAM_ACCORDION = 'home team accordion',
  IN_USE_TAB = 'in use tab',
  INFO_ICON = 'info icon',
  INFO_MENU = 'info menu',
  INPUT_ELEMENT = 'input element',
  INTRO_COMPONENT = 'intro component',
  INVITATION = 'invitation',
  IS_TEMPLATE = 'isTemplate',
  JAVASCRIPT = 'javascript',
  LABEL = 'label',
  LABELS = 'labels',
  LABELS_FILTER = 'labels filter',
  LANDING_TAB = 'landing tab',
  LANGUAGE = 'language',
  LEARN_MORE = 'learn more',
  LESS_ACTIVE_BOARDS = 'less active boards',
  LINK = 'link',
  LIST = 'list',
  LIST_LIMIT = 'list limit',
  LIST_LIMIT_MENU = 'list limit menu',
  LIST_MENU = 'list menu',
  LOCATION = 'location',
  MAP = 'map',
  MEMBER = 'member',
  MEMBER_CARDS = 'member cards',
  MEMBER_SEARCH_RESULT = 'member search result',
  MEMBER_MENU = 'member menu',
  MEMBER_PAGE = 'member page',
  MEMBERS = 'members',
  MEMBERS_FILTER = 'members filter',
  MENU = 'menu',
  MOONSHOT = 'moonshot',
  MOONSHOT_WELCOME_POPOVER = 'moonshot welcome popover',
  NOTIFICATION = 'notification',
  NOTIFICATIONS = 'notifications',
  NOTIFICATIONS_MENU = 'notifications menu',
  OBSERVER = 'observer',
  ONBOARDING_MENU = 'onboarding menu',
  ONBOARDING_SUCCESS_MODAL = 'onboarding success modal',
  ORGANIZATION = 'team', // Standardizing on terminology
  ORGANIZATIONS = 'teams', // Standardizing on terminology
  OVERDUE_BANNER = 'overdue banner',
  OVERDUE_CARDS_MENU = 'overdue cards menu',
  OVERDUE_CARDS_TIMESPAN_MENU = 'overdue cards timespan menu',
  OVERDUE_CARDS_TIMESPAN = 'overdue cards timespan',
  OVERFLOW_MENU = 'overflow menu',
  PERFORMANCE = 'performance',
  PLUGIN = 'power-up', // Standardizing on terminology
  PLUGINS = 'power-ups', // Standardizing on terminology
  POWER_UP = 'power-up',
  POWER_UPS = 'power-ups',
  POWER_UPS_ADMINISTRATION = 'power-ups administration',
  POWER_UPS_DIRECTORY = 'power-ups directory',
  POWER_UPS_GET_STARTED = 'power-ups get started',
  POWER_UPS_LISTING = 'power-ups listing',
  POWER_UPS_LIST = 'power-ups list',
  POWER_UPS_PAGE = 'power-ups page',
  PRIVATE = 'private',
  PROFILE = 'profile',
  PUBLIC = 'public',
  REACTION = 'reaction',
  REACTION_SKIN_TONE = 'reaction skin tone',
  REACTIONS_PILE = 'reactions pile',
  REACTIONS_SELECTOR = 'reactions selector',
  REACTIONS_SELECTOR_CATEGORY = 'reaction selector category',
  REACTION_SELECTOR_SKIN_TONE_MENU = 'reaction selector skin tone menu',
  REPORT = 'report',
  SEARCH = 'search',
  SEARCH_INPUT = 'search input',
  SEPARATOR_TITLE = 'separator card title',
  SETTINGS = 'settings',
  SHARE_TEMPLATE_MENU = 'share template menu',
  SHOW_DUE_DATE_STATUS = 'show due date status',
  SIDEBAR = 'sidebar',
  STICKER = 'sticker',
  SUCCESS = 'success',
  SURVEY_MANAGER = 'survey-manager',
  SWITCH_TO_YEARLY_BILLING_POPOVER = 'switch to yearly billing popover',
  TEAM = 'team',
  TEAM_BILLING_PAGE_LINK = 'team billing page link',
  TEAM_BUILDER = 'team builder',
  TEAM_CREATION = 'team creation',
  TEAM_FEEDS = 'team feeds',
  TEAM_INVITATION = 'team invitation',
  TEAM_MEMBERSHIP_RESTRICTION = 'team membership restriction',
  TEAM_BOARD_CREATION_RESTRICTION = 'team board creation restriction',
  TEAM_BOARD_DELETION_RESTRICTION = 'team board deletion restriction',
  TEAM_BOARD_INVITATION_RESTRICTION = 'team board invitation restriction',
  TEAM_MENU = 'team menu',
  TEAM_PAGE = 'team page',
  TEAM_PAGE_BC_TAB = 'team page bc tab',
  TEAM_SETTINGS_PAGE = 'team settings page',
  TEAM_TAB = 'team tab',
  TEAM_TAB_WELCOME_POPOVER = 'team tab welcome popover',
  TEAM_TEMPLATE_PICKER = 'team template picker',
  TEAM_PAGE_BOARD_TAB = 'team page board tab',
  TEAM_SEARCH_RESULT = 'team search result',
  TEAMS = 'teams',
  TEAM_DASH_POWER_UPS_TAB = 'team dashboard power-ups tab',
  TEAM_REPORTS_PAGE = 'team reports page',
  TEAM_VIEW = 'team view',
  TEAMLESS_COLLABORATION_PROMPT = 'teamless collaboration prompt',
  TEMPLATE = 'template',
  TEMPLATE_CATEGORY = 'template category',
  TEMPLATES_GALLERY = 'templates gallery',
  TEMPLATES_STORY_PAGE = 'templates story page',
  TERMS_OF_SERVICE = 'terms of service',
  TILE = 'tile',
  TO_A_COMMENT = 'to a comment',
  TURN_OFF_MENU = 'turn off menu',
  UPCOMING_CARDS_MENU = 'upcoming cards menu',
  UPCOMING_CARDS_TIMESPAN = 'overdue cards timespan',
  UPCOMING_CARDS_TIMESPAN_MENU = 'upcoming cards timespan menu',
  UPDATE_PAYMENT_METHOD_PROMPT = 'update payment method prompt',
  USER = 'member', // Standardizing on terminology
  USERS = 'members', // Standardizing on terminology
  USER_MENU = 'user menu',
  VISIBILITY = 'visibility',
  WARNING_MENU = 'warning menu',
  WEBSOCKET_DISCONNECTION = 'websocket disconnection',
  WORKSPACES_PREAMBLE_ADD_TO_TEAM_PROMPT = 'workspaces preamble add to team prompt',
  WORKSPACES_PREAMBLE_BOARD_INVITE_PROMPT = 'workspaces preamble board invite prompt',
  WORKSPACES_PREAMBLE_ADD_TO_TEAM_BUTTON = 'workspaces preamble add to team button',
  WORKSPACES_PREAMBLE_BOARD_INVITE_BUTTON = 'workspaces preamble board invite button',
}

export enum Verb {
  ACCEPTS = 'accepts',
  ADDS = 'adds',
  ALLOWS = 'allows',
  ARCHIVES = 'archives',
  BLURS = 'blurs',
  CHANGES = 'changes',
  CHECKS = 'checks',
  CLICKS = 'clicks',
  CLOSES = 'closes',
  COMPLETES = 'completes',
  COPIES = 'copies',
  CREATES = 'creates',
  DELETES = 'deletes',
  DISABLES = 'disables',
  DISMISSES = 'dismisses',
  DISPLAYS = 'shows', // Standardizing on terminology
  ENABLES = 'enables',
  EXECUTES = 'executes',
  EXPORTS = 'exports',
  FILTERS = 'filters',
  GENERATES = 'generates',
  HIDES = 'hides',
  HIGHLIGHTS = 'highlights',
  INITIATES = 'initiates',
  JOINS = 'joins',
  LEAVES = 'leaves',
  LOADS_MORE = 'loads more',
  MARKS_AS_READ = 'marks as read',
  MARKS_AS_UNREAD = 'marks as unread',
  MOVES = 'moves',
  NAVIGATES = 'navigates',
  OPENS = 'opens',
  OPT_IN_TO = 'opt in to',
  OPT_OUT_OF = 'opt out of',
  ORDERS = 'orders',
  REACTIVATES = 'reactivates',
  REFRESHES = 'refreshes',
  REMOVES = 'removes',
  RENDERS = 'renders',
  REORDERS = 'reorders',
  REVOKES = 'revokes',
  SAVES = 'saves',
  SEARCHES = 'searches',
  SENDS = 'sends',
  SETS = 'sets',
  SHOWS = 'shows',
  SHOWS_ALL = 'shows all',
  SHOWS_FEWER = 'shows fewer',
  SHOWS_MORE = 'shows more',
  SHOWS_UNREAD = 'shows unread',
  SKIPS = 'skips',
  SORTS = 'orders', // Standardizing on terminology
  STARS = 'stars',
  SUBSCRIBES = 'subscribes',
  SUBMITS = 'submits',
  UNCHECKS = 'unchecks',
  UNSTARS = 'unstars',
  UNSUBSCRIBES = 'unsubscribes',
  UNWATCHES = 'unsubscribes', // Standardizing on terminology
  UPDATES = 'updates',
  UPLOADS = 'uploads',
  VIEWS = 'views',
  WATCHES = 'subscribes', // Standardizing on terminology
}
